module.exports = __webpack_public_path__ + "static/media/ilustra_HP.a709bc84.jpg";